var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "promotions-container" },
    [
      _vm.promotions && _vm.promotions.length > 0
        ? _c(
            "div",
            { staticClass: "promotions-wrapper" },
            _vm._l(_vm.promotions, function(promotion, i) {
              return _c(
                "div",
                {
                  key: i,
                  staticClass: "promotion-item",
                  class: promotion.event,
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.togglePromotion(promotion)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "promotion-banner" }, [
                    _c("div", {
                      staticClass: "promo-img",
                      style: [
                        {
                          backgroundImage:
                            "url(" +
                            _vm.mediaServer(
                              "/static/promotions/generic_banner_" +
                                (i % 2 === 0 ? 1 : 2) +
                                ".jpg"
                            ) +
                            ") !important"
                        }
                      ]
                    }),
                    _vm._v(" "),
                    _c("p", { staticClass: "promotion-title" }, [
                      _vm._v(_vm._s(promotion.description))
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "promotion-text-generic" }, [
                      _vm._v(_vm._s(_vm.$t("Promotions.BaseBannerText")))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "promo-content" }, [
                    _c("div", { staticClass: "promotion-note" }, [
                      _vm._v(
                        "\n          " + _vm._s(promotion.note) + "\n        "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "promo-buttons" },
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "event-btn",
                            on: {
                              click: function($event) {
                                return _vm.moreInfo(
                                  promotion.description,
                                  promotion.idmmprpromotype,
                                  promotion.id,
                                  promotion.idmpcampaign
                                )
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.isLoggedIn ||
                                    promotion.idmmprpromotype === "REGISTRATION"
                                    ? _vm.$t(
                                        "Promotions.Action." +
                                          promotion.idmmprpromotype
                                      )
                                    : _vm.$t("Promotions.Login") +
                                        " " +
                                        _vm.$t(
                                          "Promotions.Action." +
                                            promotion.idmmprpromotype
                                        )
                                ) +
                                "\n          "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.promotions && _vm.promotions.length === 0
        ? _c("div", [
            _c(
              "p",
              { staticClass: "no-promotions-found" },
              [
                _c(
                  "v-icon",
                  { staticClass: "mr-1", attrs: { color: "info", size: "18" } },
                  [_vm._v("info")]
                ),
                _vm._v(
                  _vm._s(
                    _vm.$t("Promotions.AccountPage.NoActivePromotions.Msg")
                  )
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { row: "", "justify-center": "" } },
        [
          _c(
            "v-dialog",
            {
              attrs: {
                "content-class": "dialog-promotions-static-content",
                "max-width": "1154"
              },
              model: {
                value: _vm.popupDialog,
                callback: function($$v) {
                  _vm.popupDialog = $$v
                },
                expression: "popupDialog"
              }
            },
            [
              _c(
                "div",
                { staticClass: "closeDialog" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "close",
                      attrs: { flat: "" },
                      on: {
                        click: function($event) {
                          return _vm.closePopupDialog()
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "promotion-popup-content" }, [
                _vm.html
                  ? _c("div", {
                      staticClass: "promotion-text",
                      domProps: { innerHTML: _vm._s(_vm.html) }
                    })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isLoggedIn || _vm.promoType === "ALLPLAYERS"
                  ? _c(
                      "div",
                      { staticClass: "popup_buttons" },
                      [
                        _vm.promoType && !_vm.isLoggedIn
                          ? _c(
                              "v-btn",
                              {
                                staticClass: "event-btn",
                                attrs: { flat: "flat" },
                                on: {
                                  click: function($event) {
                                    return _vm.action(_vm.promoType)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.promoType === "REGISTRATION"
                                        ? _vm.$t(
                                            "Promotions.Action.REGISTRATION"
                                          )
                                        : _vm.$t("Promotions.Login") +
                                            " " +
                                            _vm.$t(
                                              "Promotions.Action." +
                                                _vm.promoType
                                            )
                                    ) +
                                    "\n            "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.promoType === "ALLPLAYERS" && _vm.isLoggedIn
                          ? _c(
                              "v-btn",
                              {
                                staticClass: "event-btn",
                                attrs: { flat: "flat" },
                                on: {
                                  click: function($event) {
                                    return _vm.action(_vm.promoType)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t(
                                        "Promotions.Action." + _vm.promoType
                                      )
                                    ) +
                                    "\n            "
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isLoggedIn &&
                (_vm.promoType === "REFERAFRIEND" ||
                  _vm.promoType === "PICKCLAIM")
                  ? _c(
                      "div",
                      { staticClass: "promo_components_holder" },
                      [
                        _vm.promoType === "REFERAFRIEND"
                          ? [_c("ReferAFriend")]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.promoType === "PICKCLAIM"
                          ? [
                              _c("PickAndClaim", {
                                attrs: {
                                  promoId: _vm.promoId,
                                  campaignId: _vm.campaignId,
                                  isOnPsPromotionsPage: true
                                }
                              })
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  : _vm._e()
              ])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-788627ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-788627ba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/PromotionsPage.vue
// module id = null
// module chunks = 